/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SchoolBell-E API
 * SchoolBell 레거시 플랫폼 리소스 OAuth AS + RS
 * OpenAPI spec version: 1.0
 */
import {
  HttpClient,
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import {
  Observable
} from 'rxjs';

import type {
  ConfirmMemberPickerSessionDto,
  ExchangeMemberPickerSessionDto,
  MemberPickerSelectionResultDto,
  MemberPickerSessionContextDto,
  MemberPickerSessionCreatedDto
} from './models';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};







@Injectable({ providedIn: 'root' })
export class SchoolBellEAPIService {
  private readonly http = inject(HttpClient);
/**
 * @summary (RP 백엔드용) 멤버 피커 세션 생성 — org access token(Bearer)
 */
 memberPickerControllerCreateSession<TData = MemberPickerSessionCreatedDto>( options?: HttpClientBodyOptions): Observable<TData>;
 memberPickerControllerCreateSession<TData = MemberPickerSessionCreatedDto>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 memberPickerControllerCreateSession<TData = MemberPickerSessionCreatedDto>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  memberPickerControllerCreateSession<TData = MemberPickerSessionCreatedDto>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/oauth/member-picker/sessions`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/oauth/member-picker/sessions`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/oauth/member-picker/sessions`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary (팝업용, 무인증) 세션의 org 멤버·팀 목록 + postMessage 대상 origin 조회
 */
 memberPickerControllerGetSessionContext<TData = MemberPickerSessionContextDto>(code: string, options?: HttpClientBodyOptions): Observable<TData>;
 memberPickerControllerGetSessionContext<TData = MemberPickerSessionContextDto>(code: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 memberPickerControllerGetSessionContext<TData = MemberPickerSessionContextDto>(code: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  memberPickerControllerGetSessionContext<TData = MemberPickerSessionContextDto>(
    code: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/oauth/member-picker/sessions/${code}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/oauth/member-picker/sessions/${code}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/oauth/member-picker/sessions/${code}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary (팝업용, 무인증) 선택 확정 — teamIds/labelIds 해소해 스냅샷 저장
 */
 memberPickerControllerConfirmSession<TData = void>(code: string,
    confirmMemberPickerSessionDto: ConfirmMemberPickerSessionDto, options?: HttpClientBodyOptions): Observable<TData>;
 memberPickerControllerConfirmSession<TData = void>(code: string,
    confirmMemberPickerSessionDto: ConfirmMemberPickerSessionDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 memberPickerControllerConfirmSession<TData = void>(code: string,
    confirmMemberPickerSessionDto: ConfirmMemberPickerSessionDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  memberPickerControllerConfirmSession<TData = void>(
    code: string,
    confirmMemberPickerSessionDto: ConfirmMemberPickerSessionDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/oauth/member-picker/sessions/${code}/confirm`,
      confirmMemberPickerSessionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/oauth/member-picker/sessions/${code}/confirm`,
      confirmMemberPickerSessionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/oauth/member-picker/sessions/${code}/confirm`,
      confirmMemberPickerSessionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

/**
 * @summary (RP 백엔드용) 확정된 선택 결과를 client_secret으로 최종 교환(1회 소비)
 */
 memberPickerControllerExchangeSession<TData = MemberPickerSelectionResultDto>(code: string,
    exchangeMemberPickerSessionDto: ExchangeMemberPickerSessionDto, options?: HttpClientBodyOptions): Observable<TData>;
 memberPickerControllerExchangeSession<TData = MemberPickerSelectionResultDto>(code: string,
    exchangeMemberPickerSessionDto: ExchangeMemberPickerSessionDto, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 memberPickerControllerExchangeSession<TData = MemberPickerSelectionResultDto>(code: string,
    exchangeMemberPickerSessionDto: ExchangeMemberPickerSessionDto, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  memberPickerControllerExchangeSession<TData = MemberPickerSelectionResultDto>(
    code: string,
    exchangeMemberPickerSessionDto: ExchangeMemberPickerSessionDto, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/oauth/member-picker/sessions/${code}/exchange`,
      exchangeMemberPickerSessionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/oauth/member-picker/sessions/${code}/exchange`,
      exchangeMemberPickerSessionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/oauth/member-picker/sessions/${code}/exchange`,
      exchangeMemberPickerSessionDto,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }

};
